module.exports = __webpack_public_path__ + "static/media/entrantesyaperitivos_checked.d5754a0b.svg";